var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_11274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.50012H2.50004C1.57957 3.50012 0.833374 4.24632 0.833374 5.16679V18.5002C0.833374 19.4206 1.57957 20.1668 2.50004 20.1668H18.5C19.4205 20.1668 20.1667 19.4206 20.1667 18.5002V5.16679C20.1667 4.24632 19.4205 3.50012 18.5 3.50012Z",
    stroke: "black",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.807617 8.50024H20.1922",
    stroke: "black",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1538 1V5.16667",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84607 1V5.16667",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_11274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.3d8385c415a0b970587782194bc8ce8b.svg";
export { ForwardRef as ReactComponent };